import { MapPin } from "lucide-react";
import { useLocationAddress } from "@/hooks/useLocationAddress";

interface LocationDisplayProps {
  companyId: string | undefined;
  latitude: number | null;
  longitude: number | null;
}

export function LocationDisplay({ companyId, latitude, longitude }: LocationDisplayProps) {
  const { data: locationData, isLoading } = useLocationAddress(
    companyId,
    latitude ?? undefined,
    longitude ?? undefined
  );

  if (!latitude || !longitude) {
    return (
      <p className="text-xs text-muted-foreground mt-1 flex items-center gap-1">
        <MapPin className="h-3 w-3 text-yellow-600" />
        <span className="text-yellow-600">Localização não capturada</span>
      </p>
    );
  }

  return (
    <div className="text-xs mt-1">
      <a
        href={`https://www.google.com/maps?q=${latitude},${longitude}`}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-1 text-blue-600 hover:underline"
      >
        <MapPin className="h-3 w-3" />
        <span>
          {isLoading 
            ? 'Carregando endereço...' 
            : (locationData?.formatted || 'Endereço não disponível')}
        </span>
      </a>
    </div>
  );
}
